<template>
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item, index) in routeMeta" :key="index">{{item}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
</template>

<script>
export default {
  data() {
    return {
      // 路由中的标签值
      routeMeta: [],
    }
  },
  computed: {
  },
  mounted() {
    // 页面初次调用route里的值
    this.routeMeta = this.$route.meta.bread
    console.log(this.routeMeta,789)
    // 计算容器高度
    this.$nextTick(function() {
      let windowHeight = document.getElementsByClassName('header')[0].clientHeight
      this.$emit('labelHeight', windowHeight)
    //   this.$store.commit('saveBarHeight', windowHeight)
    });
  },
  
  methods: {
  },
};
</script>

<style scoped>
.header{
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/Breadcrumb.vue